import type { IconSvgObject } from './types';

const VeganIcon: IconSvgObject = [
  ["path", { d: "M3.5 6C5.83333 7.875 10.5 13.5 10.5 21C10.5 14.4635 14.0446 9.35119 16.5 6.9043", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.437 9.06301C13.1877 7.8137 13.1877 5.78815 14.437 4.53884C16.3221 2.65376 20.4692 3.03078 20.4692 3.03078C20.4692 3.03078 20.8462 7.17794 18.9612 9.06301C18.542 9.48222 18.0354 9.76076 17.5 9.89864", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default VeganIcon;
